import comp from "./TaggableInputField";
export default comp;
